import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from '@jll/icon';
import styles from './menu.scss';

const componentMainClass = 'menu__item';
const componentParentClass = 'menu';

class MenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.isOpen
        };
    }

    handleClick = () => {
        this.setState(prevState => {
            return { open: !prevState.open };
        });
    };

    render() {
        const { className, children, href, target, isActive, isOpen, placeholder, openClassName, ...other } = this.props;
        const getStyles = classNames.bind(styles);

        const componentClasses = getStyles(
            componentMainClass,
            {
                [`${componentMainClass}--active`]: isActive,
                [`${componentMainClass}--open`]: this.state.open
            },
            className,
            {
                [openClassName]: this.state.open
            }
        );

        const placeholderClasses = getStyles(
            componentMainClass,
            `${componentMainClass}--placeholder`,
            {
                [`${componentMainClass}--active`]: isActive,
                [`${componentMainClass}--open`]: this.state.open
            },
            className,
            {
                [openClassName]: this.state.open
            }
        );

        const placeholderArrow = getStyles(`${componentMainClass}-arrow`, 'far', 'fa-chevron-right');

        const SubMenuClasses = getStyles(
            `${componentMainClass}--has-submenu`,
            {
                [`${componentMainClass}--open`]: this.state.open
            },
            className,
            {
                [openClassName]: this.state.open
            }
        );

        const SubMenuItemsClasses = getStyles(
            `${componentParentClass}__submenu-items`,
            {
                [`${componentParentClass}__submenu-items--open`]: this.state.open
            },
            className,
            {
                [openClassName]: this.state.open
            }
        );

        const SubMenuItemClasses = getStyles(`${componentMainClass}--sub`, className);

        const MenuItemProps = {
            className: componentClasses,
            href,
            target,
            ...other
        };

        const SubMenuProps = {
            className: SubMenuClasses,
            ...other
        };

        let renderContent;

        if (React.Children.count(children) > 1) {
            renderContent = (
                <div {...SubMenuProps}>
                    <button type="button" className={placeholderClasses} onClick={this.handleClick}>
                        {placeholder}
                        <Icon className={placeholderArrow} />
                    </button>
                    <div className={SubMenuItemsClasses}>
                        {React.Children.map(children, item =>
                            React.cloneElement(item, {
                                className: SubMenuItemClasses
                            })
                        )}
                    </div>
                </div>
            );
        } else {
            renderContent = <a {...MenuItemProps}>{children}</a>;
        }

        return renderContent;
    }
}

MenuItem.propTypes = {
    /** The class of the menu item. */
    className: PropTypes.string,
    /** An Menu item's placeholder */
    placeholder: PropTypes.string,
    /** Avatar link. On click navigates user somewhere. If there is no link, you can assign onClick action instead. */
    href: PropTypes.string,
    /** The target of the link. Possible target props are identical to <a target=""> tag props. */
    target: PropTypes.string,
    /** Menu item's active state */
    isActive: PropTypes.bool,
    /** Menu item's open state, when subnav is opened */
    isOpen: PropTypes.bool,
    /** The class of the menu item when open */
    openClassName: PropTypes.string
};

MenuItem.defaultProps = {
    className: '',
    placeholder: '',
    href: '',
    target: '',
    isActive: false,
    isOpen: false,
    openClassName: ''
};

export default MenuItem;
